import React from "react";
import classes from "./InputRadio.module.scss";
import Pix from "../../../../assets/images/pix.svg";
import Card from "@mui/material/Card";
import { CardActionArea } from "@mui/material";
import Radio from "@mui/material/Radio";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

const InputRadio = ({
  label = null,
  checked = null,
  onClick = null,
  image = null,
  name = "",
  value = "",
  ...rest
}) => {
  return (
    <Card
      onClick={onClick}
      className={checked ? classes.CardMainChecked : classes.CardMainUnchecked}
    >
      <CardActionArea
        className={checked ? classes.Checked : classes.Unchecked}
        style={ image ?{
          display: "grid",
          width: "100%",
          height: "100%",
          gridTemplateAreas: 
          `"checkedBox image"
          "checkedBox label"`
        } : {
          display: "grid",
          width: "100%",
          height: "100%",
          gridTemplateAreas: 
          `"checkedBox label"
          "checkedBox label"`
        }}
      >
        <Radio
          {...rest}
          className={classes.CheckedBox}
          sx={{
            color: "#808080",
            "&.Mui-checked": {
              color: "#662D91",
            },
          }}
          checked={checked}
          value={value}
          name={name}
        />
        {image && (
          <CardMedia
            className={classes.Image}
            component="img"
            image={image}
            alt="icon payment"
          />
        )}
        <Typography className={classes.Label} gutterBottom>
          {label}
        </Typography>
      </CardActionArea>
    </Card>
  );
};

export default InputRadio;
